// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

const Title = styled.h3`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.grids.colors.lightgrey};
`;

const Line = styled.span`
  display: inline-block;
  background-color: ${({ theme }) => theme.grids.colors.redlight};
  height: 2px;
  margin: 0 1em;
  flex-grow: 1;
`;

const Span = styled.span``;

type Props = {
  className?: string;
  text: string;
};

const TitleWithLine = ({ className, text }: Props) => {
  return (
    <Title className={className}>
      <Line className="line" />
      <Span>{text}</Span>
      <Line className="line" />
    </Title>
  );
};

export default TitleWithLine;
